import {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    LineSeperator,
    ErrorMark
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import LicenceSuspensionDetailsForm from "../../components/LicenceDetails/LicenceSuspensionDetailsForm"
import { 
    licenceSuspensionDetailsSelect,
    populateLicenceSuspensionQuestionForReview,
    populateLicenceSuspensionDataForReview
} from '../../redux/selector/licenceDetailsSelector'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_COLLECTOR,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    ROUTE_PATH
} from '../../app/constants'
import { IsDateInFuture, replaceCollectorName, replaceUrlParams, ValidateString } from '../../app/utils';
import Navigation from '../Navigation'
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice'
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors'
import { setAgencyLicenceSuspensionDetails } from '../../redux/slice/primaryAgencyApplicationSlice'
import { setCurrentAgentLicenceSuspsnsionDetails } from '../../redux/slice/additionalApplicationsSlice'


const LicenceSuspensionDetails = (props) => {
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const collectorApplicantDetails =  props.licenceSuspensionDetails.collectorApplicantDetails
    const licenceSuspensionDetails = props.licenceSuspensionDetails[applicationType] ? 
        props.licenceSuspensionDetails[applicationType] : props.licenceSuspensionDetails

    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const defaultSuspensionDetailObject = () => {
        return {
            businessLicenceType : "",
            province : "",
            suspensionDate : 0,
            reason: "",
            action: ""
        }
    }

    let details = []

    if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
        || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) 
    { 
        if(props.licenceSuspensionDetails.licenceSuspendedData 
            && Array.isArray( props.licenceSuspensionDetails.licenceSuspendedData) 
            && props.licenceSuspensionDetails.licenceSuspendedData.length > 0) 
        {
            details =   props.licenceSuspensionDetails.licenceSuspendedData
        } else { 
            details = [defaultSuspensionDetailObject()]
        }
    } else if(applicationType === APPLICATION_TYPE_COLLECTOR 
        || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) { 
        if(props.licenceSuspensionDetails.collectorLicenceSuspensionDetails &&
            Array.isArray(props.licenceSuspensionDetails.collectorLicenceSuspensionDetails)
            && props.licenceSuspensionDetails.collectorLicenceSuspensionDetails.length > 0 
        ) {
            details = props.licenceSuspensionDetails.collectorLicenceSuspensionDetails
        } else { 
            details = [defaultSuspensionDetailObject()]
        }
    }

    const [suspensionDetails, setSuspensionDetails] = useState(details)

    useEffect(() => {
        let details = []

        if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY 
            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) 
        { 
            if(props.licenceSuspensionDetails.licenceSuspendedData 
                && Array.isArray( props.licenceSuspensionDetails.licenceSuspendedData) 
                && props.licenceSuspensionDetails.licenceSuspendedData.length > 0) 
            {
                details =   props.licenceSuspensionDetails.licenceSuspendedData
            }
        } else if(applicationType === APPLICATION_TYPE_COLLECTOR 
            || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) { 
            if(props.licenceSuspensionDetails.collectorLicenceSuspensionDetails &&
                Array.isArray(props.licenceSuspensionDetails.collectorLicenceSuspensionDetails)
                && props.licenceSuspensionDetails.collectorLicenceSuspensionDetails.length > 0 
            ) {
                details = props.licenceSuspensionDetails.collectorLicenceSuspensionDetails
            }
        }
        
        if(details.length === 0) {
            details.push(defaultSuspensionDetailObject())
        }

        setSuspensionDetails(details)
    }, [
        applicationType,
        props.licenceSuspensionDetails.licenceSuspendedData,
        props.licenceSuspensionDetails.collectorLicenceSuspensionDetails,
        setSuspensionDetails
    ])

    const validateData = () => { 
        for(let i = 0; i < suspensionDetails.length; i++) {
            let susD = suspensionDetails[i]

            const {
                businessLicenceType,
                province,
                suspensionDate,
                reason,
                action
            } = susD

            if(ValidateString(businessLicenceType, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
                return false
            } else if(ValidateString(province, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
                return false
            } else if(ValidateString(suspensionDate, VALIDATION_TYPE.DATE_VALID) !== VALIDATION_ERROR.NO_ERROR) {
                return false
            } else if(IsDateInFuture(suspensionDate)) {
                return false
            } else if(ValidateString(reason,VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
                return false
            } else if(ValidateString(action, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
                return false
            }
        }

        return true
    }

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    const onNextClick =() => {

        setApplicationSaveError(false)

        if(!validateData()) {
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        if(applicationType === APPLICATION_TYPE_COLLECTOR || 
            applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
            dispatch(setCurrentAgentLicenceSuspsnsionDetails(suspensionDetails))
        } else { 
            dispatch(setAgencyLicenceSuspensionDetails(suspensionDetails))
        }

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
        .then((data) => {
            let nextUrl = licenceSuspensionDetails.navigation.next

            if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY || 
                applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
                if(props.licenceSuspensionDetails.additionalBranches 
                    && Array.isArray(props.licenceSuspensionDetails.additionalBranches )
                    && props.licenceSuspensionDetails.additionalBranches.length > 0) { 
                        nextUrl = ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS
                    }
            }

            if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
                && licenceSuspensionDetails.navigation.nextRenewal) {
                nextUrl = licenceSuspensionDetails.navigation.nextRenewal
            }
            dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const onAddDetailsClick = () => {
        let updatedSuspensionDetails = [...suspensionDetails, defaultSuspensionDetailObject()]
        setSuspensionDetails(updatedSuspensionDetails)
    }

    const onDetailsChange = (update) => {
        let index = parseInt(update.id)
        let updatedSuspensionDetails = [...suspensionDetails]
        let updatedDetails = Object.assign({}, suspensionDetails[index], update.updatedDetails)
        updatedSuspensionDetails.splice(index, 1,updatedDetails)
        setSuspensionDetails(updatedSuspensionDetails)
    }

    let suspensionDetailsComponents = []

    suspensionDetails.forEach((element, key) => {
        suspensionDetailsComponents.push(
            <div key={key} className="bottomMarginNormal">
                <div className="row">
                    <div className={"col-lg-8 bottomMarginNormal"}>
                        <LicenceSuspensionDetailsForm 
                            id={key} 
                            onDetailsChange={onDetailsChange}
                            businessLicenceType={element.businessLicenceType}
                            province={element.province}
                            action={element.action}
                            suspensionDate={element.suspensionDate}
                            reason={element.reason} 
                            showValidationError={showValidationError}
                        />
                    </div>
                    <div className={"col-lg-4"}>
                        <NavigationLinkButton
                                id={"branch-remove-link"}
                                text={"- Remove licence suspension"}
                                onClick={() => {
                                    let updatedSuspensionDetails = [...suspensionDetails]
                                    updatedSuspensionDetails.splice(key,1)
                                    setSuspensionDetails(updatedSuspensionDetails)

                                    /*
                                    let details = [...branches]
                                    details.splice(index, 1)
                                    setBranches(details)
                                    */
                                }}
                        />
                    </div>
                </div>
                <LineSeperator />
            </div>
        )
    });

    let reviewData = []
    if(viewMode === VIEW_MODE_RENEWAL_PREVIEW)
        reviewData = populateLicenceSuspensionDataForReview(details)

    let paragraphText = ((viewMode === VIEW_MODE_RENEWAL_PREVIEW) ?
                            licenceSuspensionDetails.textRenewal : 
                            licenceSuspensionDetails.text)
    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        let collectorName = "Collector"

        if(collectorApplicantDetails && collectorApplicantDetails.firstName) {
            collectorName = collectorApplicantDetails.firstName
        }

        paragraphText = paragraphText.map((text) => replaceCollectorName(text,collectorName))
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
            {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode && 
            <>
                <TopNavigationBar {...props} />
                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <Header 
                            id={"licence-suspension-details-header"}
                            header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ?
                                licenceSuspensionDetails.headerRenewal : licenceSuspensionDetails.header} 
                        />
                        <Paragraph id={"licence-suspension-details-paragraph"}
                            text={paragraphText} 
                        />
                    </div>
                </div>
            </>
            }
            <div className={"row"}>
                <div className={"col-lg-12"}>
                    {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                    <>
                        <ReviewForm data={populateLicenceSuspensionQuestionForReview(details)} />
                        {
                            reviewData.map((suspensionData, index) => {
                                return (
                                    <div key={"review-licence-suspension-data-" + index}>
                                        <ReviewForm data={suspensionData} />
                                        {(index < reviewData.length - 1)
                                            && <LineSeperator />} 
                                    </div>
                                )
                            })
                        }
                    </>
                    }
                    {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                        suspensionDetailsComponents
                    }
                </div>
            </div>
            {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                <div className={"row bottomMarginNormal"}>
                    <div className={"col-lg-8"}>
                        <NavigationLinkButton 
                            id={"licence-suspension-details-add-more"}
                            text={"+ Add a business licence suspension"}
                            onClick={onAddDetailsClick}
                        />
                    </div>
                </div>
            }
            {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT !== viewMode && 
                <div className={"row bottomMarginNormal"}>
                    <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                        <Button
                            id="licence-suspension-details-next-button" 
                            text="Save and next"
                            buttonType="regular_primary"
                            onClick={onNextClick}
                        />
                        {applicationSaveError && ErrorMark()}
                        {applicationSaveError && <div className="help-block topMarginNormal">
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>}
                    </div>
                    {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="col-lg-4">
                        <NavigationLinkButton 
                            id={"licence-history-details-edit-mode-switch"}
                            text={"Update this information before continuing"}
                            onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                        />
                    </div>}
                </div>
            }
            {VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT === viewMode && 
                <div className={"row bottomMarginNormal"}>
                    <div className={"col-lg-8"}>
                        <Button
                            id="licence-suspension-details-edit-mode-save-button"
                            text="Save"
                            buttonType="regular_primary"
                            onClick={() => {
                                
                                if(!validateData()) {
                                    setShowValidationError(true)
                                    return
                                }
                        
                                setShowValidationError(false)

                                if(applicationType === APPLICATION_TYPE_COLLECTOR ||
                                    applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                    dispatch(setCurrentAgentLicenceSuspsnsionDetails(suspensionDetails))
                                } else { 
                                    dispatch(setAgencyLicenceSuspensionDetails(suspensionDetails))
                                }
                                props.onEditSave()
                            }}
                        />
                    </div>
                </div>
            }
        </div>
        </>
    )
}

export default connect(licenceSuspensionDetailsSelect)(LicenceSuspensionDetails)
